export default __webpack_public_path__ + "assets/65a5d6.svg";